// F4 Report 3: Quotation Discussion
import React, { useEffect, useState } from "react";
import { fetchReportQuotation } from "../../api/service";
import ReportShell, { display, downloadReportCsv } from "./ReportShell";

const QuotationReport = () => {
  const [rows, setRows] = useState([]);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let alive = true;
    fetchReportQuotation()
      .then((res) => {
        if (!alive) return;
        setRows(res?.rows || []);
        setCount(res?.count || 0);
      })
      .catch((e) => alive && setError(e?.message || "Failed to load"))
      .finally(() => alive && setLoading(false));
    return () => { alive = false; };
  }, []);

  return (
    <ReportShell
      title="3. Quotation Discussion"
      count={count}
      loading={loading}
      error={error}
      onExport={() => downloadReportCsv("quotation_discussion")}
    >
      <div className="table-responsive">
        <table className="table table-bordered table-hover align-middle">
          <thead className="table-light">
            <tr>
              <th className="text-center">Project</th>
              <th className="text-center">Sales Members</th>
              <th className="text-center">Ageing (days)</th>
              <th className="text-center">Gross Quote Value</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr><td colSpan={4} className="text-center text-muted py-4">No projects in this stage.</td></tr>
            ) : rows.map((r) => (
              <tr key={r.project_id}>
                <td className="text-center">{r.project_label}</td>
                <td className="text-center">{display(r.sales_members)}</td>
                <td className="text-center">{display(r.ageing_days)}</td>
                <td className="text-center">{display(r.gross_quote_value)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </ReportShell>
  );
};

export default QuotationReport;
